class ProductCardMediaDots {
  constructor(card) {
    this.card = card;
    this.dotsWrapper = card.querySelector('[data-product-card-media-dots]');

    if (!this.dotsWrapper) return;

    this.slider =
      card.querySelector('slideshow-slides') ||
      card.querySelector('[ref="slides"]') ||
      card.querySelector('.slideshow__slides') ||
      card.querySelector('.product-card__media');

    if (!this.slider) return;

    this.slides = Array.from(
      this.slider.querySelectorAll('slideshow-slide, .slideshow-slide, [ref="slide[]"]')
    );

    if (this.slides.length <= 1) {
      this.dotsWrapper.remove();
      return;
    }

    this.init();
  }

  init() {
    this.dotsWrapper.innerHTML = '';

    this.dots = this.slides.map((slide, index) => {
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'product-card-media-dots__button';
      button.setAttribute('aria-label', `Go to image ${index + 1}`);
      button.dataset.index = index;

      if (index === 0) {
        button.classList.add('is-active');
      }

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        this.goToSlide(index);
      });

      this.dotsWrapper.appendChild(button);

      return button;
    });

    this.observeSlides();
  }

  goToSlide(index) {
    const slide = this.slides[index];

    if (!slide) return;

    this.slider.scrollTo({
      left: slide.offsetLeft,
      behavior: 'smooth',
    });

    this.setActiveDot(index);
  }

  setActiveDot(index) {
    this.dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
    });
  }

  observeSlides() {
    const observer = new IntersectionObserver(
      (entries) => {
        const visibleEntry = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (!visibleEntry) return;

        const index = this.slides.indexOf(visibleEntry.target);

        if (index >= 0) {
          this.setActiveDot(index);
        }
      },
      {
        root: this.slider,
        threshold: 0.6,
      }
    );

    this.slides.forEach((slide) => observer.observe(slide));
  }
}

function initProductCardMediaDots() {
  document.querySelectorAll('product-card, .product-card').forEach((card) => {
    if (card.dataset.mediaDotsInit === 'true') return;

    card.dataset.mediaDotsInit = 'true';
    new ProductCardMediaDots(card);
  });
}

document.addEventListener('DOMContentLoaded', initProductCardMediaDots);
document.addEventListener('shopify:section:load', initProductCardMediaDots);